module.exports = __webpack_public_path__ + "img/home-05.3b9fe8a6.jpg";